import moment from "moment";
import { z } from "zod";

export const nativeSourceTypes = [
  "conversation",
  "project_conversation",
  "wiki_person",
  "wiki_project",
  "routine_template",
] as const;

export const providerSourceTypes = [
  "project_knowledge",
  "slack",
  "notion",
  "gdrive",
  "confluence",
  "github",
  "microsoft",
  "gmail",
  "granola",
] as const;

const nativeRoute = z
  .string()
  .trim()
  .regex(/^\/(?!\/)[^\\\u0000-\u001f\u007f]*$/);

const providerUrl = z
  .string()
  .trim()
  .url()
  .refine((value) => {
    try {
      const url = new URL(value);
      return (
        url.protocol === "https:" && url.username === "" && url.password === ""
      );
    } catch {
      return false;
    }
  });

const proposalFields = {
  title: z.string().trim().min(3).max(200),
  rationale: z.string().trim().min(10).max(1000),
  evidence: z.string().trim().min(8).max(2000),
  confidence: z.literal("high"),
  sourceId: z.string().trim().min(1),
  sourceTitle: z.string().trim().min(1).nullable(),
  dueOn: z
    .string()
    .refine((value) => {
      const dueOn = moment(value, "YYYY-MM-DD", true);
      return dueOn.isValid() && dueOn.year() >= 1;
    })
    .nullable(),
};

export const MorningBriefingTaskProposalSchema = z.union([
  z.object({
    ...proposalFields,
    sourceType: z.enum(nativeSourceTypes),
    sourceUrl: nativeRoute,
  }),
  z.object({
    ...proposalFields,
    sourceType: z.enum(providerSourceTypes),
    sourceUrl: providerUrl,
  }),
]);

export type MorningBriefingTaskProposal = z.infer<
  typeof MorningBriefingTaskProposalSchema
>;
